import React, { useEffect, useState } from "react";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
import "../css/flaticon.min.css";
import "../css/fontawesome-5.14.0.min.css";
import "../Main.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import emailjs from "@emailjs/browser";
import {
  EMAILJS_SERVICE_ID,
  EMAILJS_CONTACT_TEMPLATE_ID,
  EMAILJS_AUTOREPLY_TEMPLATE_ID,
  EMAILJS_PUBLIC_KEY,
} from "../emailjsConfig";

const Cloud = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [demoData, setDemoData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const [isDemoSubmitting, setIsDemoSubmitting] = useState(false);

  const handleBookDemo = async () => {
    try {
      setIsDemoSubmitting(true);
      const params = {
        name: `${demoData.firstName} ${demoData.lastName}`.trim(),
        mail: demoData.email,
        from_email: demoData.email,
        phonenumber: demoData.phone,
        subject: `Book a Demo - ${demoData.service}`,
        address: "",
        message: demoData.message,
      };
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_CONTACT_TEMPLATE_ID,
        params,
        { publicKey: EMAILJS_PUBLIC_KEY }
      );
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_AUTOREPLY_TEMPLATE_ID,
        params,
        { publicKey: EMAILJS_PUBLIC_KEY }
      );
      setDemoData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        service: "",
        message: "",
      });
      setIsModalOpen(false);
      alert("Your demo request has been sent. We'll reach out soon!");
    } catch (err) {
      alert("Something went wrong. Please try again.");
    } finally {
      setIsDemoSubmitting(false);
    }
  };
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>
          Best Cloud Computing Services in Chennai - The Tech Horse
        </title>
        <meta
          name="description"
          content="Get reliable cloud computing services in Chennai. Secure, scalable, and cost-effective cloud solutions for businesses. Contact us for a free consultation!"
        />
      </Helmet>
      <Header />
      <section className="page-banner-area cloud-banner pt-245 rpt-150 pb-170 rpb-100 rel z-1 bgc-lighter text-center">
        <div className="container">
          <div className="banner-inner rpt-10">
            <h1 className="page-title wow fadeInUp delay-0-2s">
              {t("cloudBannerH")} <span>{t("cloudBannerSpan")}</span>
            </h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-center wow fadeInUp delay-0-4s">
                <li className="breadcrumb-item">
                  <Link to="/">
                    {t("cloudBannerHome")}
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#fff" }}
                >
                  {t("cloudBannerHomeSpan")}
                </li>
              </ol>
            </nav>
            <div className="banner-btn mt-4 wow fadeInUp delay-0-6s">
              <button
                className="theme-btn"
                onClick={() => setIsModalOpen(true)}
              >
                Book a Demo
              </button>
            </div>
          </div>
        </div>
        <div className="banner-shapes">
          <div
            className="circle cloudcircle wow zoomInLeft delay-0-2s"
            data-wow-duration="2s"
          />
          <img
            className="shape-one"
            src="/images/shapes/hero-shape1.png"
            alt="Shape"
            loading="lazy"
          />
          <img
            className="shape-two"
            src="/images/shapes/hero-shape2.png"
            alt="Shape"
            loading="lazy"
          />
        </div>
      </section>
      {/* Statistics Five Area Start */}
      <section className="statistics-area-five py-80">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-6">
              <div className="statistics-five-content mb-30 rmb-65 wow fadeInRight delay-0-2s">
                <div className="section-title mb-25">
                  <span className="sub-title style-two cloudHead mb-15">
                    {t("cloudCompH")}
                  </span>
                  <h2>{t("cloudCompSub")} </h2>
                </div>
                <p>{t("cloudCompPara")}</p>
                <Link to="/contact-us" className="theme-btn cloudlearn style-two mt-15">

                  {t("learnMoreBtn")}{" "}
                  <i className="fas fa-angle-double-right" />

                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="statistics-five-image wow fadeInLeft delay-0-2s">
                <img
                  src="/assets/6 cloud/img1.webp"
                  alt="Statistics"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Statistics Five Area end */}
      {/* Services Area start */}
      <section className="services-area pt-80 pb-80 rel z-1">
        <div className="container">
          <div className="section-title text-center mb-55">
            <span className="sub-title mb-15 cloudHead">{t("cloudSerH")}</span>
            <h2>{t("cloudSerSub")}</h2>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="service-item cloudboxHov cloudboxHov wow fadeInUp delay-0-2s">
                <div className="icon">
                  <i className="fi fi-tr-model-cube cloudboxicon" />
                </div>
                <div className="content">
                  <h5>
                    {t("cloudSerli1H")}
                  </h5>
                  <p>{t("cloudSerli1Para")} </p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="service-item cloudboxHov wow fadeInUp delay-0-4s">
                <div className="icon">
                  <i className="fi fi-tr-file-medical-alt cloudboxicon" />
                </div>
                <div className="content">
                  <h5>
                    {t("cloudSerli2H")}
                  </h5>
                  <p>{t("cloudSerli2Para")}</p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="service-item cloudboxHov wow fadeInUp delay-0-6s">
                <div className="icon">
                  <i className="flaticon-optimization cloudboxicon" />
                </div>
                <div className="content">
                  <h5>
                    {t("cloudSerli3H")}
                  </h5>
                  <p>{t("cloudSerli3Para")}</p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="service-item cloudboxHov wow fadeInUp delay-0-8s">
                <div className="icon">
                  <i className="fi fi-tr-nfc-lock cloudboxicon" />
                </div>
                <div className="content">
                  <h5>
                    {t("cloudSerli4H")}
                  </h5>
                  <p> {t("cloudSerli4Para")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Services Area end */}
      <section className="why-choose-two-area py-80 rel z-1">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-6">
              <div className="why-choose-two-image rmb-65 wow fadeInUp delay-0-4s">
                <img
                  src="/assets/6 cloud/img2.webp"
                  alt="why choose us"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="col-xl-5 col-lg-6">
              <div className="why-choose-two-content wow fadeInUp delay-0-2s">
                <div className="section-title mb-35">
                  <span className="sub-title style-two mb-15 cloudHead">
                    {t("cloudwhyH")}
                  </span>
                  <h2>{t("cloudwhySub")}</h2>
                </div>
                <ul className="list-style-one cloudul">
                  <li>
                    <div className="content">
                      <h5>{t("cloudwhyLi1H")}</h5>
                      <p>{t("cloudwhyLi1Para")}</p>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <h5>{t("cloudwhyLi2H")}</h5>
                      <p>{t("cloudwhyLi2Para")}</p>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <h5>{t("cloudwhyLi3H")}</h5>
                      <p>{t("cloudwhyLi3Para")}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="call-to-action-area bgc-black pt-80 pb-80"
        style={{ backgroundColor: "#ecbe88" }}
      >
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-xl-7 col-lg-9">
              <div className="section-title text-white mb-25 wow fadeInUp delay-0-2s">
                <h2>{t("cloudEveH")}</h2>
                <p>{t("cloudEvePara")}</p>
              </div>
            </div>
            <div className="col-lg-3 text-lg-end">
              <Link to="/contact-us" className="theme-btn cloudLearnbtn style-two mb-30 wow fadeInUp delay-0-4s">

                {t("cloudLetsbtn")}{" "}
                <i className="fas fa-angle-double-right" />

              </Link>
            </div>
          </div>
        </div>
      </section>
      {isModalOpen && (
        <div
          className="book-demo-overlay"
          onClick={(e) => e.target === e.currentTarget && setIsModalOpen(false)}
        >
          <div className="book-demo-modal">
            <div className="book-demo-header">
              <div>
                <h2>Book a Demo</h2>
                <p>Fill in your details and we'll get back to you within 24 hours.</p>
              </div>
              <button
                className="book-demo-close"
                onClick={() => setIsModalOpen(false)}
                aria-label="Close"
              >
                &times;
              </button>
            </div>

            <div className="book-demo-body">
              <div className="book-demo-row">
                <div className="book-demo-group">
                  <label>First Name</label>
                  <input
                    type="text"
                    placeholder="John"
                    value={demoData.firstName}
                    onChange={(e) =>
                      setDemoData({ ...demoData, firstName: e.target.value })
                    }
                  />
                </div>
                <div className="book-demo-group">
                  <label>Last Name</label>
                  <input
                    type="text"
                    placeholder="Doe"
                    value={demoData.lastName}
                    onChange={(e) =>
                      setDemoData({ ...demoData, lastName: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="book-demo-group">
                <label>Work Email</label>
                <input
                  type="email"
                  placeholder="john@company.com"
                  value={demoData.email}
                  onChange={(e) =>
                    setDemoData({ ...demoData, email: e.target.value })
                  }
                />
              </div>

              <div className="book-demo-group">
                <label>Phone Number</label>
                <input
                  type="tel"
                  placeholder="+1 (555) 000-0000"
                  value={demoData.phone}
                  onChange={(e) =>
                    setDemoData({ ...demoData, phone: e.target.value })
                  }
                />
              </div>

              {/* <div className="book-demo-group">
                <label>Company Name</label>
                <input type="text" placeholder="Acme Inc." />
              </div> */}

              <div className="book-demo-group">
                <label>Service Interested In</label>
                <select
                  value={demoData.service}
                  onChange={(e) =>
                    setDemoData({ ...demoData, service: e.target.value })
                  }
                >
                  <option value="" disabled>Select a service</option>
                  <option>Web Design</option>
                  <option>Web Development</option>
                  <option>SEO &amp; Marketing</option>
                  <option>Other</option>
                </select>
              </div>

              <div className="book-demo-group">
                <label>Message (Optional)</label>
                <textarea
                  placeholder="Tell us about your project..."
                  rows={3}
                  value={demoData.message}
                  onChange={(e) =>
                    setDemoData({ ...demoData, message: e.target.value })
                  }
                />
              </div>

              <button
                className="theme-btn w-100 mt-10"
                onClick={handleBookDemo}
                disabled={isDemoSubmitting}
              >
                {isDemoSubmitting ? "Sending..." : "Schedule Demo"}
              </button>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default Cloud;
